import React from 'react'
import SettingsFinanceForm from '../components/setting/settingsFinanceForm'

const SettingsFinance = () => {
    return (<SettingsFinanceForm />
    )
}

export default SettingsFinance